import { render, staticRenderFns } from "./ChangeLayout.vue?vue&type=template&id=34577e0c&scoped=true"
import script from "./ChangeLayout.vue?vue&type=script&lang=js"
export * from "./ChangeLayout.vue?vue&type=script&lang=js"
import style0 from "./ChangeLayout.vue?vue&type=style&index=0&id=34577e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34577e0c",
  null
  
)

export default component.exports